"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Verified = createSVGIcon(
  <>
    <path
      d="M.072 3.45 8.505 0l8.432 3.45s.142 6.979 0 8.275-.488 3.03-2.886 5.444C11.655 19.58 8.506 20 8.506 20s-3.434-.638-5.588-2.831S.235 13.02.072 11.725c-.162-1.296 0-8.275 0-8.275"
      fill="currentColor"
    />
    <path
      d="m5 9.852 2.185 2.184 4.851-4.851"
      stroke="#fff"
      strokeLinecap="round"
    />
  </>,
  "Verified",
  { viewBox: "0 0 17 20", titleAccess: "Verified", className: legacyIconCls() }
);
